export const administrationAccountsDepartmentRsc = {
    template: require('./administration-accounts-department-rsc.html'),
    controller: 'AdministrationAccountsDepartmentRscController'
};
